<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  
   <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
 <Strong>*In case the child has not attended any school prior to this, kindly mention NA. </Strong></br>
    <Strong v-if="this.is_unicode_note == 'true' || this.is_unicode_note == true">* जर मुलाने यापूर्वी कोणत्याही शाळेत शिक्षण घेतले नसेल, तर कृपया NA नमूद करा.</Strong>
    <v-form
      id="lastschoolattended_form"
      @submit.prevent="submit"
      v-model="isValid"
      v-if="loader"
    >
      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <input
            type="hidden"
            :value="application_form_data.admission_form_id"
            name="admission_form_id"
          /> </v-col
      ></v-row>
      <v-row dense justify="center" v-if="previous_school_name">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="previous_school_name.required">*</v-icon>
          <v-text-field
            dense
            v-model.trim="previous_school_name.field_value"
            :value="previous_school_name.field_value"
            :name="previous_school_name.field_name"
            :required="previous_school_name.required"
            :rules="previous_school_name.required ? [v => !!v || previous_school_name.field_display_name+' is required'] : []"
            :clearable="previous_school_name.required? false : true"
            :hint=previous_school_name.field_display_name
            persistent-hint
            :prepend-icon="previous_school_name.field_value!=null ? 'mdi-school' : 'mdi-school-outline'"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="previous_school_udise_no">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="previous_school_udise_no.required">*</v-icon>
          <v-text-field
            dense
            v-model.trim="previous_school_udise_no.field_value"
            :value="previous_school_udise_no.field_value"
            :name="previous_school_udise_no.field_name"
            :required="previous_school_udise_no.required"
            :rules="previous_school_udise_no.required ? [v => !!v || previous_school_udise_no.field_display_name+' is required'] : []"
            :clearable="previous_school_udise_no.required? false : true"
            :hint=previous_school_udise_no.field_display_name
            persistent-hint
            :prepend-icon="previous_school_udise_no.field_value!=null ? 'mdi-school' : 'mdi-school-outline'"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="previous_school_address">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="previous_school_address.required">*</v-icon>
          <v-text-field
            dense
            v-model.trim="previous_school_address.field_value"
            :value="previous_school_address.field_value"
            :name="previous_school_address.field_name"
            :required="previous_school_address.required"
            :rules="previous_school_address.required ? [v => !!v || previous_school_address.field_display_name+' is required'] : []"
            :clearable="previous_school_address.required? false : true"
            :hint=previous_school_address.field_display_name
            persistent-hint
            prepend-icon="mdi-home"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="no_of_years_in_previous_school">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="no_of_years_in_previous_school.required">*</v-icon>
          <v-text-field
            dense
            v-model.trim="no_of_years_in_previous_school.field_value"
            :value="no_of_years_in_previous_school.field_value"
            :name="no_of_years_in_previous_school.field_name"
            :required="no_of_years_in_previous_school.required"
            :rules="no_of_years_in_previous_school.required ? [v => !!v || no_of_years_in_previous_school.field_display_name+' is required'] : []"
            :clearable="no_of_years_in_previous_school.required? false : true"
            :hint=no_of_years_in_previous_school.field_display_name
            persistent-hint
            prepend-icon="mdi-alpha-n-circle"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
     
      <v-row dense justify="center" v-if="previous_school_passing_standard">
        <v-col cols="10" sm="10" md="10">
           <v-icon color="error" v-if="previous_school_passing_standard.required">*</v-icon>
          <v-autocomplete
            dense
            :items="previous_school_passing_standard.options"
            v-model.trim="previous_school_passing_standard.field_value"
            :name="previous_school_passing_standard.field_name"
            :required="previous_school_passing_standard.required"
            :rules="previous_school_passing_standard.required ? [v => !!v ||previous_school_passing_standard.field_display_name+ ' is required'] : []"
            :clearable="previous_school_passing_standard.required ? false : true"
            return-object
            single-line
            prepend-icon="mdi-alpha-g-circle"
            outlined
            :hint=previous_school_passing_standard.field_display_name
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="previous_school_board">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="previous_school_board.required">*</v-icon>
          <v-autocomplete
            dense
            :items="previous_school_board.options"
            v-model.trim="previous_school_board.field_value"
            :name="previous_school_board.field_name"
            :required="previous_school_board.required"
            :rules="previous_school_board.required ? [v => !!v ||previous_school_board.field_display_name+ ' is required'] : []"
            :clearable="previous_school_board.required ? false : true"
            return-object
            single-line
            prepend-icon="mdi-certificate"
            outlined
            :hint=previous_school_board.field_display_name
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="previous_school_obtained_percentage">
        <v-col cols="10" sm="10" md="10">
           <v-icon color="error" v-if="previous_school_obtained_percentage.required">*</v-icon>
          <v-text-field
            dense
            v-model.trim="previous_school_obtained_percentage.field_value"
            :value="previous_school_obtained_percentage.field_value"
            :name="previous_school_obtained_percentage.field_name"
            :required="previous_school_obtained_percentage.required"
            :rules="previous_school_obtained_percentage.required ? [v => !!v || previous_school_obtained_percentage.field_display_name+' is required'] : []"
            :clearable="previous_school_obtained_percentage.required ? false : true"
            :hint=previous_school_obtained_percentage.field_display_name
            persistent-hint
            :prepend-icon="previous_school_obtained_percentage.field_value ? 'mdi-percent' : 'mdi-percent-outline'"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
        <v-row dense justify="center" v-if="previous_school_obtained_percentage_new">
        <v-col cols="10" sm="10" md="10">
           <v-icon color="error" v-if="previous_school_obtained_percentage_new.required">*</v-icon>
          <v-text-field
            dense
            type="number"
            v-model.trim="previous_school_obtained_percentage_new.field_value"
            :value="previous_school_obtained_percentage_new.field_value"
            :name="previous_school_obtained_percentage_new.field_name"
            :required="previous_school_obtained_percentage_new.required"
            :clearable="previous_school_obtained_percentage_new.required ? false : true"
            :hint=previous_school_obtained_percentage_new.field_display_name
            persistent-hint
            :prepend-icon="previous_school_obtained_percentage_new.field_value ? 'mdi-percent' : 'mdi-percent-outline'"
            outlined
          ></v-text-field>
            <!-- :rules="previous_school_obtained_percentage_new.required ? [v => !!v ||previous_school_obtained_percentage_new.field_display_name+ ' is required'] : []" -->
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="previous_school_last_year">
        <v-col cols="10" sm="10" md="10">
           <v-icon color="error" v-if="previous_school_last_year.required">*</v-icon>
          <v-autocomplete
            dense
            :items="previous_school_last_year.options"
            v-model="previous_school_last_year.field_value"
            :value="previous_school_last_year.field_value"
            :name="previous_school_last_year.field_name"
            :required="previous_school_last_year.required"
            :rules="previous_school_last_year.required ? [v => !!v || previous_school_last_year.field_display_name+' is required'] : []"
            :clearable="previous_school_last_year.required ? false : true"
            return-object
            single-line
            :prepend-icon="
              previous_school_last_year.field_value!=null ? 'mdi-calendar-month' : 'mdi-calendar-month-outline'
            "
            outlined
           :hint=previous_school_last_year.field_display_name
            persistent-hint
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="reason_for_leaving_last_school">
        <v-col cols="10" sm="10" md="10">
           <v-icon color="error" v-if="reason_for_leaving_last_school.required">*</v-icon>
          <v-text-field
            dense
            :value="reason_for_leaving_last_school.field_value"
           v-model.trim="reason_for_leaving_last_school.field_value"
            :name="reason_for_leaving_last_school.field_name"
            :required="reason_for_leaving_last_school.required"
            :rules="reason_for_leaving_last_school.required ? [v => !!v || reason_for_leaving_last_school.field_display_name+' is required'] : []"
            :clearable="reason_for_leaving_last_school.required ? false : true"
            :hint=reason_for_leaving_last_school.field_display_name
            persistent-hint
            :prepend-icon="reason_for_leaving_last_school.field_value!=null ? 'mdi-alpha-r-circle' : 'mdi-alpha-r-circle-outline'"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
       <v-row dense justify="center" v-if="date_of_leaving_previous_school">
        <v-col cols="10" sm="10" md="10">
           <v-icon color="error" v-if="date_of_leaving_previous_school.required">*</v-icon>
           <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on,attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model.trim="date_of_leaving_previous_school.field_value"
                :name="date_of_leaving_previous_school.field_name"
                :hint=date_of_leaving_previous_school.field_display_name
                persistent-hint
                prepend-icon="event"
                @blur="date = parseDate(date_of_leaving_previous_school.field_value)"
                v-on="on"
                :required="date_of_leaving_previous_school.required"
                :rules="
                  date_of_leaving_previous_school.required
                    ? [
                        v =>
                          !!v ||
                          date_of_leaving_previous_school.field_display_name + ' is required'
                      ]
                    : []
                "
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>

          <!-- <v-text-field
            dense
            :value="date_of_leaving_previous_school.field_value"
            v-model="date_of_leaving_previous_school.field_value"
            :name="date_of_leaving_previous_school.field_name"
            :required="date_of_leaving_previous_school.required"
            :rules="date_of_leaving_previous_school.required ? [v => !!v || ' is required'] : []"
            :clearable="date_of_leaving_previous_school.required ? false : true"
            hint="Date Of Leaving Previous School"
            persistent-hint
            :prepend-icon="date_of_leaving_previous_school.field_value!=null ? 'mdi-alpha-r-circle' : 'mdi-alpha-r-circle-outline'"
            outlined
          ></v-text-field> -->
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="prizes">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="prizes.required">*</v-icon>
          <v-text-field
            dense
            :value="prizes.field_value"
            v-model.trim="prizes.field_value"
            :name="prizes.field_name"
            :required="prizes.required"
            :rules="prizes.required ? [v => !!v || ' is required'] : []"
            :clearable="prizes.required ? false : true"
            :hint=date_of_leaving_previous_school.field_display_name
            persistent-hint
            :prepend-icon="prizes.field_value!=null ? 'mdi-seal-variant' : 'mdi-seal-variant-outline'"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center" dense>
        <v-col cols="10" sm="10" md="10">
          <div style="text-align:center">
            <v-btn
              class="mt-2"
              :color="isValid ? 'primary darken-1' : 'grey lighten-1'"
              @click="submit"
              :disabled="!isValid"
              >Save</v-btn
            >
          </div>
        </v-col></v-row
      >

      <!-- <v-row dense justify="center" >
        <v-col cols="10" sm="10" md="10">
          <h4>*In case the child has not attended any school prior to this, kindly mention NA in the Previous School Name.</h4>
        </v-col>
      </v-row> -->
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isValid: true,
      snackbar_msg: "",
       loader: false,
      color: "",
      snackbar: false,
      application_form_data: {
        admission_form_no: "",
        admission_form_id: "",
        display_admission_form_no: ""
      },
      previous_school_name: null,
      previous_school_udise_no: null,
      previous_school_passing_standard: null,
      previous_school_board: null,
      previous_school_obtained_percentage: null,
      previous_school_obtained_percentage_new: null,
      previous_school_last_year: null,
      reason_for_leaving_last_school: null,
      prizes: null,no_of_years_in_previous_school:null,previous_school_address:null,

      date_of_leaving_previous_school: {},
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      is_unicode_note: ""
    };
  },
  methods: {
    submit: function(e) {
      this.loader = false;
      var form = document.getElementById("lastschoolattended_form");
      var formData = new FormData(form);
      axios.post("/admissionForm/saveLastSchoolAttended", formData).then(
        response => {
          // success callback
     
          if (response.data.form_saved == "YES") {
            this.showSnackbar(
              "#4caf50",
              'Saved Successfully...Click on "Upload Documents" tab to Continue'
            ); // show snackbar on success
          }
          this.loader = true;
          this.$store.commit('setform_progress', response.data.form_progress)
        },
        response => {
          // error callback
          this.showSnackbar(
              "#b71c1c",
              'Error'
            ); // show snackbar on success
        }
      );
    },
    getform() {
      axios
        .post(
          "/admissionForm/getLastSchoolAttended",this.application_form_data 
        )
        .then(res => {
          if (res.data.msg == "200") {
             this.previous_school_name=res.data.previous_school_name
             this.previous_school_udise_no=res.data.previous_school_udise_no
             this.previous_school_passing_standard=res.data.previous_school_passing_standard
             this.previous_school_obtained_percentage=res.data.previous_school_obtained_percentage
             this.previous_school_obtained_percentage_new=res.data.previous_school_obtained_percentage_new
             this.previous_school_last_year=res.data.previous_school_last_year
             this.prizes=res.data.prizes
             this.reason_for_leaving_last_school=res.data.reason_for_leaving_last_school
             this.previous_school_board=res.data.previous_school_board;
             this.previous_school_address=res.data.previous_school_address
             this.no_of_years_in_previous_school=res.data.no_of_years_in_previous_school
             this.date_of_leaving_previous_school=res.data.date_of_leaving_previous_school
             this.loader = true;
             this.$store.commit('setform_progress', res.data.form_progress)

            //console.log(this.previous_school_passing_standard)
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
     formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
  watch: {
    date(val) {
      this.date_of_leaving_previous_school.field_value = this.formatDate(this.date);
    }
  },
  mounted() {
    this.is_unicode_note = localStorage.getItem("is_unicode_note");
    this.application_form_data = this.$store.getters.application_form_data;
    this.getform();
  }
};
</script>
